import React, { useEffect, useMemo, useState } from 'react';
import MasterService from '../services/master/MasterService';

const KotaKab = ({ id }) => {
    let masterService = useMemo(() => new MasterService(), [])
    const [kotakab, setKotakab] = useState('')

    useEffect(() => {
        const getKotakab = async () => {
            try {
                const response = await masterService.getKotaById(id)
                setKotakab(response.data.uraianKota)
            } catch (error) {
                setKotakab('')
            }
        }
        getKotakab()
    }, [masterService, id])

    return (
        <>
            {kotakab}
        </>
    )
}

export default KotaKab